import { DataEntryMode } from '../../../types/DataEntryMode';
import { PanelType } from '../../../types/PanelType';
import { BoardMembersValidationEditSchema } from '../../../types/Validation/BoardMembersValidationEditSchema';
import { BoardMembersValidationSchema } from '../../../types/Validation/BoardMembersValidationSchema';
import FormTextbox from '../../FormInputs/FormTextbox/FormTextbox';
import Panel from '../../Panel/Panel';
import { BoardMembersFormViewModel } from 'src/types/BoardMembersFormViewModel';
import FormDropdown from '../../../components/FormInputs/FormDropdown/FormDropdown';
import { SelectOption } from '../../../types/SelectOption';

interface BoardMembersInformationProps {
  dataEntryMode: DataEntryMode;
  formViewModel: BoardMembersFormViewModel;
  allowEdit?: boolean;
  stateOptions: SelectOption[];
}

const BoardMembersHomeAddressPanel: React.FC<
  BoardMembersInformationProps
> = ({ dataEntryMode,
      allowEdit,
      stateOptions }) => {

  return (
    <Panel panelType={PanelType.INFO} heading="Home Address">
      <div className="field-row">
        <FormTextbox
          displayName="Address Street Number and Name"
          field="streetNumberAndName"
          validationSchema={
            dataEntryMode === 'new'
              ? BoardMembersValidationSchema
              : BoardMembersValidationEditSchema
          }
          disabled={!allowEdit}
        />
        <FormTextbox
          displayName="Apt., Suite, Unit, Building, Floor, Etc."
          field="apartmentRoomOrSuiteNumber"
          validationSchema={
            dataEntryMode === 'new'
              ? BoardMembersValidationSchema
              : BoardMembersValidationEditSchema
          }
          disabled={!allowEdit}
        />
			</div>
      <div className="field-row">
        <FormTextbox
          displayName="City"
          field="addressCity"
          validationSchema={
            dataEntryMode === 'new'
              ? BoardMembersValidationSchema
              : BoardMembersValidationEditSchema
          }
          disabled={!allowEdit}
        />
        <FormDropdown
          displayName="State"
          field="addressStateAbbreviation"
          options={stateOptions}
          validationSchema={
            dataEntryMode === 'new'
              ? BoardMembersValidationSchema
              : BoardMembersValidationEditSchema
          }
          disabled={!allowEdit}
          isClearable
        />
        <FormTextbox
          displayName="Zip Code"
          field="addressPostalCode"
          validationSchema={
            dataEntryMode === 'new'
              ? BoardMembersValidationSchema
              : BoardMembersValidationEditSchema
          }
          disabled={!allowEdit}
        />
      </div>
    </Panel>
  );
};

export default BoardMembersHomeAddressPanel;
